import React from "react";
import { StoryCard } from "../../atoms/story-card";
import { connect } from "react-redux";
import "./styles.m.css";
import PropTypes from "prop-types";

const RelatedStories = ({ relatedStories, config, color = "transparent" }) => {
  const style = {
    "border-left": `3px solid ${color}`
  };
  return relatedStories.length ? (
    <div>
      <div styleName="related-stories-title" style={style}>
        {" "}
        Related Stories
      </div>
      <div styleName="related-stories">
        {relatedStories &&
          relatedStories.map((item, index) => {
            return (
              <StoryCard
                story={item.story}
                key={`{${item.id}${index}}`}
                config={config}
                className="related-story-cards"
                showAuthor
                showSection
                imageAspectRatio="1200, 630"
              />
            );
          })}
      </div>
    </div>
  ) : null;
};

export default connect(state => ({ config: state.qt.config }))(RelatedStories);

RelatedStories.propTypes = {
  relatedStories: PropTypes.array,
  config: PropTypes.object,
  color: PropTypes.string
};
